import React, { useEffect, useState , useContext} from "react";
import { Link} from "react-router-dom";
import { Spinner } from "react-bootstrap";
import $ from 'jquery';
import { useParams } from "react-router-dom";
import ReactGA from "react-ga4";
import UrlHouse from "../../utils/UrlHouse";
import DefaultProfile from '../../asset/default_profile.png';
import VerifiedBadge from '../../asset/verified_badge.png';
import { AppContext } from "../../utils/AppContext";
import { UserData } from "../../utils/UserData";
import Logo from '../../asset/logo_long_transparent_cropped.png';

import "../../spinner.css";

import { useNavigate } from "react-router-dom";

import { Row, Col, Form, Button, Card } from 'react-bootstrap';

import DecorationImage from '../../asset/login_decoration.jpg';

import {Helmet} from "react-helmet";

const VerifyEmailPage = () => {
    const appContext = useContext(AppContext);
    const [isLoaded, setIsLoaded] = useState(false);
    const [email, setEmail] = useState("");
    const [retryCountDown, setCountDown] = useState(10);
    const [retryEnabled, setRetryEnabled] = useState(true);
    const navigate = useNavigate();

    const desktopStyles = {
        mainContainerStyle: {
            width: "100%",
            display: "flex",
            textAlign: "center",
            padding: "30px",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: "column",
        },
    }

    const mobileStyles = {
        mainContainerStyle: {
            width: "100%",
            padding: "30px",
        }
    }

    const styles = appContext.mobileMode ? mobileStyles : desktopStyles

    useEffect(() => {
      //$('body').css('background-color','#2E80EB');
      init();
    }, [])

    const init = () => {
        setIsLoaded(false);
        $.ajax({
            type: "POST",
            url: UrlHouse.VERIFY_EMAIL_INIT,
            data: JSON.stringify({
                email: localStorage.getItem("email"), password: localStorage.getItem("password")
            }),
            dataType: "json",
            success: function (response) {
                if(response.result === 1){
                    navigate('/dashboard');
                }else if(response.result === 2){
                    navigate('/connect/woilo');
                }else if(response.result === 3){
                    setIsLoaded(true);
                    setEmail(response.advertiser_email);
                    setupRetry();
                }else{
                    navigate('/login');
                }
            },
            error: function(e){
                navigate('/login');
            }
        });
    }

    const check = () => {
        setIsLoaded(false);
        $.ajax({
            type: "POST",
            url: UrlHouse.VERIFY_EMAIL_CHECK,
            data: JSON.stringify({
                email: localStorage.getItem("email"), password: localStorage.getItem("password")
            }),
            dataType: "json",
            success: function (response) {
                if(response.result === 1){
                    navigate('/dashboard');
                }else if(response.result === 2){
                    navigate('/connect/woilo');
                }else if(response.result === 3){
                    setIsLoaded(true);
                }else{
                    navigate('/login');
                }
            },
            error: function(e){
                navigate('/login');
            }
        });
    }

    function retry(){
        if(!retryEnabled){
            return;
        }
        setRetryEnabled(false);
        init();
    }

    function setupRetry(){
        var timeleft = 10;
        var downloadTimer = setInterval(function(){
            if(timeleft <= 0){
                clearInterval(downloadTimer);
            }
            setCountDown(timeleft);
            timeleft -= 1;
        }, 1000);
    }

    const params = useParams();
    const [linkPreview, setLinkPreview] = useState({
        title: "Woilo - Photo, Video, Chat, NFTs",
        description: "Woilo - Photo, Video, Chat, NFTs",
        url: "",
        imageUrl: ""
    })

    return(
        <>
            <div style={styles.outerContainerStyle}>
                <Helmet>
                    <title>{linkPreview.title}</title>

                    <meta property="og:title" content={linkPreview.title} />
                    <meta property="og:description" content={linkPreview.description} />
                    <meta property="og:image" content={linkPreview.imageUrl} />
                    <meta property="og:url" content={linkPreview.url} />
                    <meta property="og:type" content="website"/>

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:domain" content="woilo.com" />
                    <meta property="twitter:url" content={linkPreview.url} />
                    <meta name="twitter:title" content={linkPreview.title} />
                    <meta name="twitter:description" content={linkPreview.description} />
                    <meta name="twitter:image" content={linkPreview.imageUrl} />
                </Helmet>
                {
                    isLoaded?
                    <div style={styles.mainContainerStyle}>
                        <h2>Verifikasi Email Kamu</h2>
                        <label>Kami telah mengirim email verifikasi ke {email}</label>
                        <br></br>
                        <br></br>
                        <label>Tidak menerima email? Klik tombol dibawah</label>
                        <Form>
                            <Form.Group as={Row} className="mb-3" style={{marginTop: "10px"}}>
                                <Col sm={{ span: 12}}>
                                    <Button onClick={retry} style={styles.sendButtonStyle} disabled={retryCountDown > 0 || !retryEnabled}>
                                        Kirim Ulang {retryCountDown>0?(" (" + retryCountDown + ")"):""}
                                    </Button>
                                </Col>
                            </Form.Group>
                        </Form>
                        <br></br>
                        <br></br>
                        <label>Sudah verifikasi? Muat Ulang</label>
                        <Form>
                            <Form.Group as={Row} className="mb-3" style={{marginTop: "10px"}}>
                                <Col sm={{ span: 12}}>
                                    <Button onClick={check} style={styles.sendButtonStyle}>
                                        Muat Ulang
                                    </Button>
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    :
                    <></>
                    
                }
            </div>
        </>
    )
}

export default VerifyEmailPage;